import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

export default function MultiValue(ctx) {
  const { t } = useTranslation();
  const selection = ctx.getValue();
  return <div className={styles.multi_value}>{t("count_selected", { count: selection.length })}</div>;
}
